var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('checkbox-input',{attrs:{"disabled":!_vm.active},on:{"change":_vm.onChange},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})}
var staticRenderFns = []

export { render, staticRenderFns }